/**
 * Open board API helper — GET /challenges/open. Mirrors the challengesApi.ts apiClient pattern.
 *
 * The endpoint takes no parameters: it returns the one page of challenges this viewer may take on,
 * closing-soonest first. Filtering and sorting are the client's job (see openBoardBrowse.helper),
 * so there is no query string to build. specs/open-challenges AC-6.
 */

import { type AxiosResponse } from 'axios';
import { logger } from '../../helpers/logger.helper';
import type { OpenBoardCard } from '../types/openBoard.types';

type ApiClientFn = <T = unknown>(endpoint: string, config?: object) => Promise<AxiosResponse<T>>;

export async function fetchOpenBoard(apiClientFn: ApiClientFn): Promise<OpenBoardCard[]> {
  try {
    const { data } = await apiClientFn<{ success: boolean; data?: OpenBoardCard[] }>(
      '/challenges/open',
      { method: 'GET' }
    );
    if (!data?.success || !Array.isArray(data.data)) return [];
    return data.data;
  } catch (error) {
    logger.error('[openBoardApi] Failed to fetch open board', { error });
    throw error;
  }
}
